"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whishlistValidationService = void 0;
var WhishlistValidationService_1 = require("../../services/wishlistValidationService/implementation/WhishlistValidationService");
exports.whishlistValidationService = new WhishlistValidationService_1.WhishlistValidationService();
//# sourceMappingURL=index.js.map